/* @flow */

export default class RegisterReferralNoteRequest {
  referrerCompanyId: number;
  refereeCompanyId: number;
  note: string;
}